import request from '@utils/request'
import configRequest from "@src/config/request";
import { type } from 'jquery';

export const state = {
  currentOption: {
    solution: {},
    resource: {}
  },
};

export const getters = {
  hasOption(state) {
    return function (option) {
      return !!state.currentOption[option] && !!state.currentOption[option]?.category;
    };
  },
};

export const mutations = {
  SET_CURRENT_OPTION(state, options) {
    state.currentOption[options.types] = options.optionsList
  },
};

export const actions = {
  /**
   * 取得選項
   * @param commit
   * @param state
   * @param getters
   * @param types
   * @param useCached
   * @param storeCached
   * @returns {Promise<AxiosResponse<any>>}
   */
  fetchOptionList({
    commit,
    state,
    getters
  }, {
    types,
    useCached = false,
    storeCached = true
  }) {
    const noCachedTypeList = getters.hasOption(types)
    const cached = () => {

      // const hasCachedList = types.filter(option => {
      //   return getters.hasOption(option)
      // });

      // hasCachedList.forEach(option => {
        const  cached = state.currentOption[types]
      // });
      return cached;
    };
    const hasCached = noCachedTypeList

    return hasCached && useCached
      ? cached()
      : request
        .get(`/iot/${types}/search/option`,{
          ...configRequest,
          name: 'fetchOptionList'
        })
        .then((response) => {
          const options = response.items
          if(storeCached) {
            const value = {
              types: types,
              optionsList: options
            }
            commit('SET_CURRENT_OPTION', value);
          }

          return options
        })
  },
};
